import React from 'react'

const ReportsPreferencesIcon = (
  <>
    <path
      d="M9.1584 9.38672L2.68262 15.4C4.3098 17.0064 6.54309 18.0001 9.00474 18.0001C13.8387 18.0001 17.7939 14.1709 17.9998 9.38672H9.1584Z"
      fill="#EFD358"
    />
    <path
      d="M9.39648 8.60349H18C17.7997 3.94923 14.0508 0.200277 9.39648 0V8.60349Z"
      fill="#704D94"
    />
    <path
      d="M8.61344 8.82431V0C3.82922 0.205868 0 4.16103 0 8.995C0 11.2176 0.81112 13.2532 2.15066 14.8256L8.61344 8.82431Z"
      fill="#E01E4E"
    />
  </>
)

export default ReportsPreferencesIcon
